<template>
    <div class="toppurchase">
        <div class="top_purchase">        
            <div id="top_purchase" style="width: 800px;height: 450px;"></div>
            <div class="drop">             
                <el-select v-model="allTime" placeholder="请选择" @change="selectType">
                    <el-option v-for="item in timeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>      
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        amount: {
            type: Array,
            default(){
                return []
            }
        },
        customer: {
            type: Array,
            default(){
                return []
            }
        }
    },
    data(){
        return {           
            allTime: 'day',
            timeList: [
                 {
                    label: '最近七天',
                    value: 'day'
                },
                {
                    label: '最近七周',
                    value: 'week'
                },
                {
                    label: '最近七月',
                    value: 'month'
                }    
            ]
        }
    },
    methods: {
        initCharts(){
            let top_echart =  window.echarts.init(document.getElementById('top_purchase'));
            let option = {
                color: ['#b21111'],
                title: {
                    text: '单位: m³',
                    textStyle: {
                        fontSize: 12,
                        color: '#aaa'
                    },
                    x: '55px',
                    y: '10px'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: [
                    {
                        type: 'category',
                        data: this.customer,
                        axisLabel: {
                            interval: 0,
                            // formatter: function(value) {
                            //     var str = value.split("")
                            //     return str.join("\n")
                            // },
                            rotate: 70
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '采购量',
                        type: 'bar',
                        barWidth: '60%',
                        data: this.amount
                    }
                ]
            }
            top_echart.setOption(option);
        },
        selectType(){
            let par = ''
            if(this.allTime=='day'){
              
                par = 0
                window.console.log('day')
            }
            if(this.allTime=='week'){
                 window.console.log('week')
                 par = 1
            }
            if(this.allTime=='month'){
                  window.console.log('month')
                par = 2
            }
            this.$emit("changeTypeEvent", par)
        }
    },
    watch: {
        amount: function(){
            this.initCharts()
        },
        customer: function(){
            this.initCharts()
        }
    }
}
</script>

<style lang="scss" scoped>
.toppurchase{
    width: 100%;
    display: flex;
    justify-content: center;
    .top_purchase{
        flex: 1;
        height: 400px;
        display: flex;
        justify-content: center;
        .drop{
          
        }
    }
}
.toppurchase /deep/ .el-input__inner{
    width: 88px;
    height: 24px;
    line-height: 24px;
    border-radius: 0;
    font-size: 12px;
    padding: 0 5px 0 10px;
    border-color: #ccc;
}
.toppurchase /deep/ .el-select__caret{
    position: relative;
    height: 24px;
    line-height: 24px;
}
.toppurchase /deep/ .el-select-dropdown__item{
    font-size: 12px;
}
</style>